<template>
  <fragment>
    <mc-app-header title="Edit Group">
      <template #right>
        <div class="level-item">
          <b-button
            :loading="groups.submitting"
            type="is-primary"
            @click="updateGroupHandler"
            >Update</b-button
          >
        </div>
      </template>
    </mc-app-header>
    <mc-app-body>
      <div class="edit-group section">
        <b-loading v-if="groups.loadingSelected" active :is-full-page="false" />
        <mc-error-layout
          v-else-if="groups.selectError"
          :message="`Failed to load group: ${groups.selectError.message}`"
          :retry-fn="() => selectGroup($route.params.id)"
        />
        <form v-else class="mc-container">
          <b-field label="Name">
            <b-input
              v-model="groups.selected.name"
              icon="format-title"
              placeholder="Group Name"
              type="text"
            />
          </b-field>
          <b-field label="Date Created">
            <mc-date-time
              v-model="groups.selected.createdAt"
              placeholder="Click to select..."
              required
            >
            </mc-date-time>
          </b-field>
        </form>
      </div>
    </mc-app-body>
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['groups'])
  },
  methods: {
    ...mapActions('groups', ['selectGroup', 'updateGroup']),
    async updateGroupHandler() {
      try {
        await this.updateGroup({
          ...this.groups.selected
        });
        this.$buefy.toast.open({
          message: 'Group updated successfully',
          type: 'is-success'
        });
      } catch (error) {
        this.$buefy.toast.open({
          message: 'Failed to update group!',
          type: 'is-danger'
        });
      }
    }
  },
  created() {
    this.selectGroup(this.$route.params.id);
  }
};
</script>

<style lang="scss" scoped>
.media-content {
  white-space: normal;
}

.edit-group {
  &__group {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 1rem;

    .field {
      flex: 1 0 0;
      margin-bottom: 0;

      &:first-child {
        margin-right: 1rem;
      }
    }
  }
}
</style>
